var React = require('react');

function IconCancelSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M511.3 65.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zM347.8 711.6l-32.2-32.2c-3.9-3.9-3.9-10.2 0-14.1L661 320c3.9-3.9 10.2-3.9 14.1 0l32.2 32.2c3.9 3.9 3.9 10.2 0 14.1L362 711.6c-3.9 3.9-10.3 3.9-14.2 0z"}));
}

IconCancelSolid.displayName = "IconCancelSolid";

IconCancelSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCancelSolid;

IconCancelSolid.default = IconCancelSolid;
